import { render, staticRenderFns } from "./Duvidas.vue?vue&type=template&id=379355f6&scoped=true&lang=pug&"
import script from "./Duvidas.vue?vue&type=script&lang=js&"
export * from "./Duvidas.vue?vue&type=script&lang=js&"
import style0 from "./Duvidas.styl?vue&type=style&index=0&id=379355f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379355f6",
  null
  
)

export default component.exports